import assetTypes from './asset-types';
import availableStrategies from './available-strategies';
import brokers from './brokers';
import countries from './countries';
import * as datasets from './datasets';
import datesFmt from './dates-fmt';
import etfCodes from './etf-codes';
import styleFactorThemes from './stylefactor-themes';
import themes from './themes';

const enabledRegions = [
  {
    region: 'United States',
    base_risk_model_id: 1187,
    factors_risk_model_id: 1166,
  },
];

const universeDefinition = {
  include_assets: true,
  exclude_assets: true,
  include_universes: false,
  exclude_universes: true,
  signals: false,
};

const defaultTemperature = 0;
const defaultResponses = 100;

export {
  assetTypes,
  availableStrategies,
  brokers,
  countries,
  datasets,
  datesFmt,
  defaultResponses,
  defaultTemperature,
  enabledRegions,
  etfCodes,
  styleFactorThemes,
  themes,
  universeDefinition,
};
